// extracted by mini-css-extract-plugin
export default {"text":"styles_text__4iHyK","button":"styles_button__3KSM0","linkIcon":"styles_linkIcon__N9+SU"};